import React from "react";

const Select = ({
	label,
	register,
	error,
	options = [],
	selectBlankOption = false,
	required = false,
	className = "",
	id,
	hideLabel = true,
}) => {
	return (
		<div className="form-field">
			{!hideLabel && (
				<label className="field-label">
					{label}
					{required && <span className="required">*</span>}
				</label>
			)}
			<select
				id={id}
				className={`field__input field__select ${
					error ? "field__input--error" : ""
				} ${className}`}
				{...register(id, {
					required: required ? "Please select an option" : false,
				})}
			>
				{selectBlankOption && <option value="">Please select...</option>}
				{options.map((option, index) => (
					<option key={index} value={option.value}>
						{option.label}
					</option>
				))}
			</select>
			{error && <div className="field__error">{error.message}</div>}
		</div>
	);
};

export default Select;
